export const serviceWorkerMessageTypes = {
  activateUpdate: "ACTIVATE_UPDATE",
  cacheVerifiedBundle: "CACHE_VERIFIED_BUNDLE",
} as const;

export const bundleCacheName = "safesphere-verified-bundles-v1";
export const activeBundlePathPrefix = "/__offline/verified-bundle/";
export const editorialImageCacheName = "safesphere-editorial-images-v1";
export const editorialImagePaths = new Set([
  "/images/preparedness-hero-v2.webp",
  "/images/learning-everyday-v1.webp",
  "/images/learning-weather-v1.webp",
  "/images/learning-outdoors-v1.webp",
  "/images/learning-accident-prevention-v1.png",
  "/images/learning-accidents-v1.png",
  "/images/learning-first-aid-v1.png",
  "/images/learning-practical-tips-v1.png",
  "/images/learning-survival-v1.png",
  "/images/learning-disasters-v1.png",
  "/images/learning-chemicals-v1.png",
  "/images/learning-medicines-v1.png",
  "/images/learning-food-safety-v1.png",
]);

export function activeBundlePath(locale: string): string {
  return `${activeBundlePathPrefix}${locale}`;
}

export function isServiceWorkerActivationRequest(value: unknown): boolean {
  return (
    typeof value === "object" &&
    value !== null &&
    "type" in value &&
    value.type === serviceWorkerMessageTypes.activateUpdate
  );
}
